module.exports = __webpack_public_path__ + "static/media/Green.18870c94.mp4";